import type { IJWTUserPayload } from "../../../interfaces/JWTUserPayload";

export function isTokenValid(token: IJWTUserPayload | undefined): boolean {
  if (!token) {
    return false;
  }

  if (token.exp === undefined) {
    return true;
  }

  const expirationInMilliseconds = token.exp * 1000;
  return expirationInMilliseconds > Date.now();
}
